import { createFileRoute } from '@tanstack/react-router';
import { JourneysMParticleHandoff } from '@/pages/workspaces/journeys/integrations/mparticle/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/mparticle_out` URL — what the Ember directory links to. Flag
 * off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment, so
 * the resolver's bundle-aware branch can rebuild the target from the bundle prefix when the
 * `/workspaces/last` sentinel needs resolving.
 */
function JourneysMParticleConnectorRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysMParticleHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out')({
  component: JourneysMParticleConnectorRoute,
});
